import { render, staticRenderFns } from "./truckInfo.vue?vue&type=template&id=8cb1eae6&scoped=true"
import script from "./truckInfo.vue?vue&type=script&lang=js"
export * from "./truckInfo.vue?vue&type=script&lang=js"
import style0 from "./truckInfo.vue?vue&type=style&index=0&id=8cb1eae6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb1eae6",
  null
  
)

export default component.exports